import React from "react";
var __jsx = React.createElement;
import Unbxd from "./Unbxd";
import { SearchPaginationContextProvider } from "@/pages/search/searchHooks/SearchPaginationContext";
var AutosRenderer = function AutosRenderer() {
  return /*#__PURE__*/React.createElement(SearchPaginationContextProvider, null, /*#__PURE__*/React.createElement(Unbxd, null));
};
export default AutosRenderer;